import React from 'react';
import image4 from '../images/teamwork.jpg';
import Carousel from './Carousel';
import uae from '../images/UAE.jpg'
import WelcomeSection from './WelcomeSection';
import { useLocation, useNavigate } from 'react-router-dom';
import mach from "../images/machine.jpg"
import PageLayout from './PageLayout';
import CountUpOnView from './CountUpOnView';



const About = () => {
 

  
  const styles = {
    section: {
      padding: '40px',
      textAlign: 'center',
      backgroundColor: '#f8f8f8',
    },
    title: {
      fontSize: '28px',
      fontWeight: 'bold',
      color: '#002f6c', // dark blue color
    },
    subtitle: {
      fontSize: '18px',
      color: '#a0a0a0', // lighter color for the subtitle
      marginBottom: '40px',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '20px',
    },
    card: {
      padding: '20px',
      backgroundColor: '#ffffff',
      border: '1px solid #ddd',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
      textAlign: 'left',
      fontSize: '16px',
    },
    quoteButton: {
      backgroundColor: '#00a0df',
      color: '#fff',
      padding: '12px 25px',
      fontSize: '16px',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      marginRight: '15px',
    },
    contact: {
      marginTop: '15px',
      fontSize: '18px',
      color: '#002f6c',
    },
    phone: {
      color: '#002f6c',
      textDecoration: 'none',
      fontWeight: 'bold',
    },
    containers: {
      marginRight:"160px",
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap', // Allows wrapping for smaller screens
      padding: '20px',
    },
    mapContainer: {
      flex: 1,
      textAlign: 'right',
      minWidth: '300px',
    },
    mapImage: {
      maxWidth: '100%',
      height: 'auto',
    },
    textContainers: {
      flex: 2,
      padding: '20px',
      maxWidth: '600px',
    },
     // Responsive adjustments
  '@media (max-width: 768px)': {
    section: {
      fontSize: '16px', // Smaller font size for tablets
    },
  
      textContainers: {
      fontSize: '16px', // Smaller font size for tablets
    },
    title: {
      fontSize: '24px', // Adjust title font size for tablets
    },
    card: {
      fontSize: '14px', // Smaller font size for cards on tablets
    },
  },
  '@media (max-width: 480px)': {
    section: {
      fontSize: '14px', // Smaller font size for mobile
    },
    textContainers: {
      fontSize: '10px', // Smaller font size for tablets
    },
    title: {
      fontSize: '20px', // Adjust title font size for mobile
    },
    card: {
      fontSize: '12px', // Smaller font size for cards on mobile
    },
  },


  };
  const location = useLocation();
  const nav = useNavigate()

  return (
    
    <div className="wholecontainer">
       
      {/* Conditionally render the Carousel only if the pathname is not "/" */}
      {location.pathname !== "/" && <Carousel />}
    
    
    <br/>
    <WelcomeSection/>
    <section className="info-section">
        <div className="info-text">
        <h2 style={{color:"black"}}><b>ABOUT SMARTSTONE</b></h2>
          <p>
          Established in 2008, Smart Stone is a trusted provider of high-quality marble flooring and stonework solutions across the UAE. The company specializes in the supply and installation of premium marble and natural stones for both interior and exterior applications, including flooring, wall cladding, and specialized architectural projects.
          <br/>
          <br/>
          With a dedication to craftsmanship, innovation, and customer satisfaction, Smart Stone has built a strong reputation for delivering exceptional service and top-quality results. Our goal is to lead the stone industry by continually exploring new products, pushing boundaries in design, and ensuring excellence in every project we undertake. We prioritize quality, precision, and client-focused solutions, all while maintaining competitive pricing and timely delivery.
          </p>
          <br/>
          <h7><strong>Some key facts about us:</strong></h7>
          <br/>
          <p>
          <ul >
            <li>Smart Stone is certified by ISO 9001:2015, ensuring adherence to the highest quality management standards in the industry.</li>
            <li>We specialize in custom marble installations, stone cladding, flooring solutions, and ornamental stonework for both residential and commercial properties.</li>
            <li>We have successfully completed a wide range of prestigious projects, including luxury villas, commercial buildings, and high-end residences throughout the UAE, in areas such as Downtown Dubai, Palm Jumeirah, and Abu Dhabi's Saadiyat Island.</li>
            <li>Our state-of-the-art facility in Dubai is equipped to handle projects of any scale, using advanced machinery and a highly skilled workforce to deliver precise and superior results.</li>
          </ul>
          </p>
          <h7><strong>Our Service:</strong></h7>
          <br/>
          <div style={{display:"flex"}}><div>
          <p>
          <ul >
            <li>Detailed shop drawings and technical support for complex projects.</li>
            <li>Project management from inception to completion, ensuring quality control and timeline adherence.</li>
            <li>Custom finishes and tailored marble and stone solutions to meet specific design needs.</li>
          </ul>
          </p>
          </div>
          <div>
            </div>
            <p>
          <ul >
            <li>Waterjet cutting technology for intricate designs and patterns in stonework.</li>
            <li>Project management from inception to completion, ensuring quality control and timeline adherence.</li>
            <li>Value engineering to maximize project efficiency and minimize costs without sacrificing quality.</li>
          </ul>
          </p>
            </div>
        </div>
      </section>
      {/* machines */}
      <div className="collection">
      <div className="text-section1">
        <h1>5 + 2 AXIS INTELLIGENCE .
        </h1>
        <p>
        This advanced 5+2 axis marble cutting machine, shown in the image, is a high-precision tool designed for cutting and shaping marble with exceptional accuracy. Featuring a robust structure and cutting-edge technology, it allows for complex cuts, detailed patterns, and smooth finishes, meeting the high standards required in the marble and stone industry. While not commonly available in the UAE, Smart Stone proudly utilizes this specialized machine, which is ideal for handling intricate marble projects, from slabs to custom shapes. Its automated functions and user-friendly controls make it a valuable asset for professionals seeking precision and efficiency in marble fabrication.
        </p>
      </div>
      <div className="image-section">
        <img src={mach} alt="Statuario marble kitchen" />
      </div>
    </div>
    <PageLayout/>

      <div className="container1">
      <div className="image-section">
        {/* Insert your image source below */}
        <img src={uae} alt="Profile" className="profile-img" />
      </div>
      <div className="text-section">
        <p>
        Smart Stone is a leading provider of premium marble flooring and custom stonework solutions across the UAE. With a reputation for exceptional craftsmanship and attention to detail, Smart Stone transforms both residential and commercial spaces with the timeless elegance of marble. Our team specializes in everything from intricate marble installations to large-scale flooring projects, delivering quality that is both beautiful and durable.
        </p>
       
        
        
      </div>
    </div>
    <section className="info-section">
    <div className="info-content">
          <div>
          <img className="info-image" src={image4} alt='' />
          </div>
          <div className="text-content">
            <h2 style={{color:"black"}}><b>Commitment to Quality & Mission</b></h2>
            <strong style={{color:"#666"}}><p></p>Commitment to Quality:</strong>
            <p> Smart Stone’s commitment to quality is evident in every project they undertake, from luxurious villas in Dubai to commercial spaces in Abu Dhabi. The company prides itself on using only premium materials, ensuring that every stone and marble slab meets the highest industry standards. Sourcing the best materials is just the beginning; Smart Stone's skilled artisans carefully craft and install these materials to achieve flawless results. Whether it's intricate stonework or expansive flooring projects, the emphasis on quality permeates every step of the process.

This dedication to superior quality is not just about meeting client expectations—it’s about exceeding them. Smart Stone employs cutting-edge technology and state-of-the-art machinery to enhance the precision and efficiency of its installations. Each project undergoes thorough quality checks to ensure that it meets the company's stringent standards. From initial consultations to the final polish, Smart Stone guarantees that the finished product is a perfect reflection of both the client's vision and the company's craftsmanship.</p>
<strong style={{color:"#666"}}><p></p>Mission:</strong>
<p>

 Smart Stone’s mission is to become a leader in the marble and stonework industry, known not only for its quality but also for its innovative approach to design and execution. The company is driven by a passion for delivering stone solutions that elevate the aesthetic appeal and functionality of any space. Their mission extends beyond the delivery of projects—it encompasses building lasting relationships with clients by consistently offering reliable service, transparent communication, and attention to detail.

Smart Stone aims to tailor its services to the unique needs of each client, understanding that every project is a new opportunity to showcase its creativity and expertise. The company seeks to combine traditional craftsmanship with modern techniques, ensuring that its installations are not only timeless in design but also robust enough to withstand the test of time. By constantly innovating and pushing the boundaries of what is possible in marble and stonework, Smart Stone continues to fulfill its mission of creating lasting value for its clients.</p>
          </div>
        
        </div>
      </section>

      <br></br>
<section className='trust-section' >
  <br/>
  <h4>Experience To Be Trusted
        </h4>
        <h1><b>Our Accomplishments</b>
        </h1>
  
      <section className='stats-section' >
        
    <div className='PROJECTS-COMPLETED' ><CountUpOnView end={450} label="Projects Completed" /></div>
    <div ><CountUpOnView end={17} label="Years of Experience" /></div>
  
  


        
        </section>
        
        
      </section>
      <section style={styles.section}>
      <h2 style={styles.title}>Our Promise To You</h2>
      <h4 style={styles.subtitle}>Bond of Trust</h4>
      <div style={styles.grid}>
        <div style={styles.card}>
          <strong>Exceptional Craftsmanship:</strong>  We promise to deliver top-tier craftsmanship in every project, ensuring the finest marble finishes that enhance the beauty of your space.
        </div>
        <div style={styles.card}>
          <strong>Premium Quality Materials:</strong> We source only the highest quality marble and stone materials, ensuring durability and longevity in all our installations.
        </div>
        <div style={styles.card}>
          <strong>Timely Delivery:</strong>  We are committed to completing your projects on time, without compromising the quality of our work.
        </div>
        <div style={styles.card}>
          <strong> Competitive Pricing:</strong> We offer competitive pricing without sacrificing the excellence you expect, ensuring that you get the best value for your investment.
        </div>
        <div style={styles.card}>
          <strong> Customer-Centric Service: </strong>Your satisfaction is our priority. We offer personalized services tailored to meet your unique needs and preferences.
        </div>
        <div style={styles.card}>
          <strong> Expert Consultation: </strong>Our team of experts provides professional consultation to help you choose the perfect marble and stone options for your project.
        </div>
        <div style={styles.card}>
          <strong>Attention to Detail: </strong>  We take pride in our attention to detail, ensuring flawless execution in every aspect of our work, from design to installation.
        </div>
        <div style={styles.card}>
          <strong>Sustainable Practices: </strong> We are committed to environmentally responsible practices, ensuring that our products and processes are eco-friendly wherever possible.
        </div>
      </div>
    </section>
    
      <section className="about-us">
            <div className="container">
                <div className="vision">
                    <h2>Our Vision</h2>
                    <p>"To become the leading provider of innovative marble and stone solutions across the UAE, setting the benchmark for quality, craftsmanship, and customer satisfaction. We aim to transform spaces with timeless, elegant designs that reflect our commitment to excellence and sustainability.”</p>
                </div>
                <div className="mission">
                    <h2>Our Mission</h2>
                    <p>“Our mission is to deliver superior marble and stonework that enhances the beauty and functionality of residential and commercial spaces. We are dedicated to exceeding customer expectations through expert craftsmanship, personalized service, and a commitment to using the finest materials. At Smart Stone, we strive to build lasting relationships with our clients by consistently delivering quality, reliability, and value in every project.”</p>
                </div>
            </div>
        </section>
        


      <div className="container1">
      <div className="image-section">
        {/* Insert your image source below */}
        <img src="" alt="Profile" className="profile-img" />
      </div>
      <div className="text-section">
        <p>
        As a marble and stonework provider, we ensure to meet the latest industry demands, and all our services are <span className="highlight">tailor-made</span> according to client requirements.
        </p>
        <div className="person-info">
          <p><strong>ROSHAN</strong></p>
          <p>Chairman, Smart Stone</p>
        </div>
        
        
      </div>
    </div>
    <section style={styles.section}>
      <div style={styles.container}>
        <div style={styles.textContainer}>
          <p style={styles.text}>
          With a large pool of highly skilled craftsmen, we ensure to meet all marble and stonework requirements in the shortest installation time, delivering exceptional results anywhere in the UAE.
          </p>
          <div style={styles.actions}>
            <button style={styles.quoteButton} onClick={()=>nav('/contact')} >REQUEST A QUOTE</button>
            <p style={styles.contact}>
              Or Call <a href="tel:+971 56 953 2313" style={styles.phone}>+971 56 6605705</a>
            </p>
          </div>
        </div>
        <div className='mobile' style={styles.containers}>
      <div style={styles.mapContainer}>
        <img
          src="https://dbdzm869oupei.cloudfront.net/img/sticker/preview/15683.png"
          alt="UAE Map"
          style={styles.mapImage}
        />
      </div>
      <div className="textAREA" style={styles.textContainers}>
        <p>
          At <strong>Smart Stone</strong>, we are proud to serve clients all across the UAE, delivering premium marble flooring and stonework to a wide range of prestigious locations. Our clients span across <strong>Dubai</strong>, where we’ve contributed to iconic projects in areas such as <strong>Downtown Dubai</strong>, <strong>Palm Jumeirah</strong>, and <strong>Dubai Marina</strong>. In <strong>Abu Dhabi</strong>, we’ve worked on luxury villas and commercial spaces in <strong>Saadiyat Island</strong> and <strong>Al Reem Island</strong>. We also serve clients in <strong>Sharjah</strong>, <strong>Ajman</strong>, <strong>Ras Al Khaimah</strong>, and <strong>Fujairah</strong>, bringing our expertise in marble craftsmanship to both residential and commercial properties across the Emirates. Our dedication to quality and excellence has earned us the trust of customers throughout the UAE.
        </p>
         
      </div>
      </div>
    </div>
      
    </section>
    </div>
    
  );
};

export default About;